<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <BannerMediaCreateAndUpdateFormItems :form="form" />
    </VForm>
</template>
<script>
import { rootActions } from '@/store/types'
import VForm from '@/components/VForm.vue'
import BannerMediaCreateAndUpdateFormItems from '@/components/BannerMediaCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        BannerMediaCreateAndUpdateFormItems,
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.ADD_BANNER_MEDIA, {
                    ...values,
                },
            )
            return res
        },
    },
}
</script>
